import React, { useState, useEffect, useRef, useCallback } from "react";
import { Toast } from "primereact/toast";

import { getCustomerChangeHistory } from "../../../services/clearing/customers";
import ReusableList from "../../../components/ReusableList";
import Loader from "../../components/Loader";

const CustomerChangeHistory = ({ customerId }) => {
  const toast = useRef(null);

  const [changesList, setChangesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    { label: "Description", value: "description" },
    { label: "Updated field", value: "updated_field" },
    { label: "Previous", value: "prev_value" },
    { label: "New", value: "new_value" },
    { label: "Updated by", value: "updated_by" },
    { label: "Updated at", value: "updated_at" },
  ];

  const loadChangesHistory = useCallback(
    async (customerId: string) => {
      if (!customerId) {
        return;
      }

      setIsLoading(true);

      try {
        const changesHistory = await getCustomerChangeHistory({ customerId });
        if (!changesHistory || changesHistory?.length === 0) {
          setChangesList([]);
          return;
        }

        setChangesList(changesHistory);
      } catch (e) {
        console.error("Failed to get changes history", e);
      } finally {
        setIsLoading(false);
      }
    },
    [setChangesList, setIsLoading]
  );

  useEffect(() => {
    if (customerId) {
      loadChangesHistory(customerId);
    }
  }, [loadChangesHistory, customerId]);

  return (
    <div className="changes-list-container">
      <Toast ref={toast} />

      {isLoading ? (
        <Loader />
      ) : (
        <ReusableList
          data={changesList}
          loading={isLoading}
          columns={columns}
          searchable={true}
          emptyMessage="No changes for this customer yet."
        />
      )}
    </div>
  );
};

export default CustomerChangeHistory;
